module.exports = __webpack_public_path__ + "static/img/e-banner.08307d76.jpg";